import { EmailMarkdownInput } from "@equidefi/ui/forms";
import type { EmailMarkdownInputProps } from "@equidefi/ui/forms/MarkdownInput";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartEmailMarkdownInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<EmailMarkdownInputProps, "name" | "value" | "onChange" | "error" | "isInvalid"> & {
  name: TName;
};

function SmartEmailMarkdownInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...markdownProps }: SmartEmailMarkdownInputProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <EmailMarkdownInput
      name={field.name}
      ref={field.ref}
      value={field.value ?? ""}
      onChange={field.onChange}
      isInvalid={!!error}
      error={error?.message}
      {...markdownProps}
    />
  );
}

export default SmartEmailMarkdownInput;
